var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    [
      _c("Icon", { attrs: { id: "clip", size: "20" } }),
      _vm._v(" "),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: {
          change: function ($event) {
            return _vm.$emit("change", $event.target.files)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }